import { Box, Card, CardContent, Chip, List, ListItem, ListItemIcon, ListItemText, Typography, useTheme, alpha } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';

const ModuleCard = ({ module, dense = false }) => {
  const theme = useTheme();
  const { name, tagline, priceLabel, priceSuffix, color, Icon, badge, summary, features } = module;

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
        '&:hover': {
          transform: 'translateY(-8px)',
          borderColor: alpha(color, 0.5),
          boxShadow: `0 18px 44px ${alpha(color, 0.22)}`,
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          height: 4,
          background: `linear-gradient(90deg, ${color}, ${alpha(color, 0.2)})`,
        },
      }}
    >
      <CardContent sx={{ p: { xs: 3, md: 3.5 }, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box
            sx={{
              width: 54,
              height: 54,
              borderRadius: 2.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color,
              bgcolor: alpha(color, theme.palette.mode === 'dark' ? 0.16 : 0.12),
            }}
          >
            <Icon sx={{ fontSize: 30 }} />
          </Box>
          {badge && (
            <Chip
              label={badge}
              size="small"
              sx={{
                bgcolor: alpha(color, 0.14),
                color,
                fontWeight: 700,
                border: `1px solid ${alpha(color, 0.3)}`,
              }}
            />
          )}
        </Box>

        <Typography variant="h5" component="h3" sx={{ mb: 0.5 }}>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {tagline}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, mb: dense ? 1 : 2 }}>
          <Typography variant="h3" component="div" sx={{ color, fontWeight: 800 }}>
            {priceLabel}
          </Typography>
          {priceSuffix && (
            <Typography variant="body2" color="text.secondary">
              {priceSuffix}
            </Typography>
          )}
        </Box>

        {!dense && summary && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {summary}
          </Typography>
        )}

        <List dense disablePadding sx={{ mt: 'auto' }}>
          {features.map((f) => (
            <ListItem key={f} disablePadding sx={{ py: 0.4 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CheckCircleRoundedIcon sx={{ fontSize: 18, color }} />
              </ListItemIcon>
              <ListItemText primary={f} primaryTypographyProps={{ variant: 'body2' }} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default ModuleCard;
